<mat-card *ngIf="invoicingData">
   <mcrit-gestio-invoice-filters
     *ngIf="showFilters"
     [validFilters]="invoiceFilters"
     (changeFilter)="computeActiveFilters($event)">
   </mcrit-gestio-invoice-filters>
   <mat-card *ngFor="let dades of invoicingData; let i = index">
    <mat-toolbar color="secondary">{{dades.projectData.titol}}</mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
    <mat-card-content style="padding: 24px;width:100%">
      <h2 mat-line>{{ 'invoicesSummary.titolDadesTreball' | translate:{ index: i } }}</h2>
      <div class="dades-pressupost-import">
       <mat-form-field>
        <input matInput style="width: 45%" placeholder="{{ 'facturacio.camps.nom' | translate }}" name="clau" disabled
          [value]="dades.projectData.clau"/>
       </mat-form-field>
       <mat-form-field>
        <input matInput style="width: 12%" placeholder="{{ 'facturacio.camps.pressupostTotal' | translate }}" name="pressupostTotal" disabled
          [value]="dades.projectData.pressupostTotal"/>
       </mat-form-field>
       <mat-form-field>
        <input matInput style="width: 15%" placeholder="{{ 'facturacio.camps.pressupostContractat' | translate }}" name="pressupostContractat" disabled
          [value]="dades.projectData.pressupostContractat"/>
       </mat-form-field>
       <mat-form-field>
        <input matInput style="width: 12%" placeholder="{{ 'facturacio.camps.impostos' | translate }}" name="importImpostos" disabled
          [value]="dades.projectData.importImpostos"/>
       </mat-form-field> 
       <mat-form-field>
        <input matInput style="width: 12%" placeholder="{{ 'facturacio.camps.garantia' | translate }}" name="importGarantia" disabled
          [value]="dades.projectData.pressupostGarantia"/>
       </mat-form-field> 
      </div>
    <table>
      <thead mat-head>
        <tr>
          <th>{{ 'invoicesSummary.colNumero' | translate }}</th>
          <th>{{ 'facturacio.taula.colActiva' | translate }}</th>
          <th>{{ 'invoicesSummary.colProjecte' | translate }}</th>
          <th mat-column>{{ 'facturacio.taula.colDataFactura' | translate }}</th>
          <th mat-column>{{ 'facturacio.taula.colDataCobrament' | translate }}</th>
          <th mat-columnmat-numeric>{{ 'facturacio.taula.colFacturacioEur' | translate }}</th>
          <th mat-columnmat-numeric>{{ 'facturacio.taula.colPercentPressupost' | translate }}</th>
          <th>{{ 'facturesRebList.colFita' | translate }}</th>
          <th>{{ 'facturesRebList.colObjecte' | translate }}</th>
          <th>{{ 'invoicesSummary.colObservacio' | translate }}</th>
          <th>{{ 'facturacio.taula.colAccions' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let finvoice of dades.invoices; let j = index">
          <td>
            {{finvoice.numero_factura}}
          </td>
          <td *ngIf="finvoice.activa">
            <mat-icon>check_box</mat-icon>
          </td>
          <td *ngIf="!finvoice.activa">
            <mat-icon>check_box_outline_blank</mat-icon>
          </td>
          <td centrat>
            {{finvoice.clau}}
          </td>
          <td>
            {{finvoice.data_factura | date}}
          </td>
          <td>
            {{finvoice.data_cobrament | date}}
          </td>
          <td number>
            {{finvoice.facturacio_prevista_eur | number:'1.0-2' }}
          </td>
          <td number>
            {{finvoice.facturacio_prevista_percent | number:'1.0-2' }}
          </td>
          <td centrat>
            {{finvoice.fita}}
          </td>
          <td centrat>
            {{finvoice.objecte_lliurament}}
          </td>
          <td>
            {{finvoice.observacions }}
          </td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td><b>{{ 'invoicesSummary.totalLabel' | translate }}</b></td>
          <td number>
            <b>{{acumulat[i].facturat | number:'1.0-2' }}</b>
          </td>
          <td number>
            <b>{{acumulat[i].percent | number:'1.0-2' }}</b>
          </td>
          <td>
            <!--  <b>{{acumulat[i].cobrat | number:'1.0-2' }}</b> -->
          </td>
          <td></td>
          <td>
            <mat-icon *ngIf="acumulat[i].percent<100" class="material-iconsmat-32" style="color:#DD0000">report_problem</mat-icon>
            <mat-icon *ngIf="acumulat[i].percent==100 && acumulat[i].facturat != acumulat[i].cobrat" class="material-iconsmat-32" style="color:#ff9000">report_problem</mat-icon>
            <mat-icon *ngIf="acumulat[i].percent==100 && acumulat[i].facturat == acumulat[i].cobrat" class="material-iconsmat-32" style="color:#008800">info</mat-icon>
          </td>
        </tr>
      </tbody>
    </table>
    </mat-card-content>
  </mat-card>
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      {{ 'facturesRebList.liniesPag' | translate }}: {{listInvoiceService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em">
      {{ 'invoicesSummary.paginaLabel' | translate }}
    </span>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <span style="text-align:center;width:20px">{{listInvoiceService.currentPage+1}}</span>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
 <mat-menu #menuNumberRows y-position="above">
     <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
 </mat-menu>
</mat-card>
